import { useNotification } from '../../../../hooks'
import { getAsyncTaskId } from '../../../../utils/async'
import { getEmailCreationSuccessNotificationProps } from '../../Email.utils'

import { checkTaskStatus } from './useMassMailingAsyncAction.utils'

export function useMassMailingAsyncAction({ onCloseModal, onReload }) {
  const { handleAddSuccessNotification } = useNotification()

  function handleAddFinishMassMailingNotification(data) {
    handleAddSuccessNotification(getEmailCreationSuccessNotificationProps(data))
    onCloseModal()
    onReload?.()
  }

  function checkAsyncMassMailingTaskStatus(data, handler) {
    checkTaskStatus(data, handler)
  }

  return {
    checkAsyncMassMailingTaskStatus,
    getAsyncTaskId,
    handleAddFinishMassMailingNotification,
  }
}
